import { useState, useCallback, useRef } from 'react';

export const useAccordionState = () => {
  const [expandedId, setExpandedId] = useState(null);
  const accordionRefs = useRef({});

  const toggleAccordion = useCallback((id) => {
    setExpandedId(prev => prev === id ? null : id);
  }, []);

  const expandAccordion = useCallback((id) => {
    setExpandedId(id);
    setTimeout(() => {
      accordionRefs.current[id]?.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'nearest'
      });
    }, 150);
  }, []);

  const collapseAll = useCallback(() => {
    setExpandedId(null);
  }, []);

  const setAccordionRef = useCallback((id, ref) => {
    accordionRefs.current[id] = ref;
  }, []);

  return {
    expandedId,
    toggleAccordion,
    expandAccordion,
    collapseAll,
    setAccordionRef,
    isExpanded: (id) => expandedId === id
  };
};
